import { getCollection } from '@adornis/baseql/server/collections.js';
import { Submission } from '../submission.js';

/** Fetches every submission for an exam, unfiltered. */
export async function getSubmissionsForExam(examId: string): Promise<any[]> {
  const submissionCollection = await getCollection(Submission as any);
  return submissionCollection.find({ examId } as any).toArray() as Promise<any[]>;
}

/** Collects every task path of an exam as dot-joined strings, e.g. "2", "2.a", "2.a.i". */
export function collectExamTaskPaths(exam: any): string[] {
  const paths: string[] = [];
  const traverse = (node: any, ancestors: string[]) => {
    const number = String(node?.taskNumber ?? '').trim();
    const path = [...ancestors, number].filter(Boolean);
    if (path.length) paths.push(path.join('.'));
    for (const child of node?.subTasks ?? []) traverse(child, path);
  };
  for (const task of exam?.tasks ?? []) traverse(task, []);
  return paths;
}

export interface FlatExamTask {
  pathStr: string;
  node: any;
}

/** Same traversal as `collectExamTaskPaths`, but keeps the node itself — needed wherever a caller wants a leaf
 *  task's own fields (taskType, needsAnswer, declaredMaxPoints, ...), not just its path. */
export function flattenExamTasks(exam: any): FlatExamTask[] {
  const flat: FlatExamTask[] = [];
  const traverse = (node: any, ancestors: string[]) => {
    const number = String(node?.taskNumber ?? '').trim();
    const path = [...ancestors, number].filter(Boolean);
    flat.push({ pathStr: path.join('.'), node });
    for (const child of node?.subTasks ?? []) traverse(child, path);
  };
  for (const task of exam?.tasks ?? []) traverse(task, []);
  return flat;
}

export interface FlatSubmissionTask {
  pathStr: string;
  node: any;
}

export function flattenSubmissionTasks(submission: any): FlatSubmissionTask[] {
  const flat: FlatSubmissionTask[] = [];
  const traverse = (node: any, ancestors: string[]) => {
    const number = String(node?.taskNumber ?? '').trim();
    const path = [...ancestors, number].filter(Boolean);
    flat.push({ pathStr: path.join('.'), node });
    for (const child of node?.subTasksSubmission ?? []) traverse(child, path);
  };
  for (const task of submission?.taskSubmissions ?? []) traverse(task, []);
  return flat;
}
